

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import BookablePackageRateDetail from './BookablePackageRateDetail'
import * as bookablePackageRateAction from '../../../../../actions/bookablePackageRateAction';
import * as amenityActions from '../../../../../actions/amenityAction';
import actions from "../../../../../actions";

const mapStateToProps = state => {
    return {
        bookablePackageRateState: state.bookablePackageRateReducer,
        file: state.uploadReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => dispatch(actions.uploadAction(filters)),
        getBookablePackageRateDetail: (id) => dispatch(bookablePackageRateAction.getBookablePackageRateDetail(id)),
        updateBookablePackageRate: (data, language, callbacks) => dispatch(bookablePackageRateAction.updateBookablePackageRate(data, language, callbacks)),
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
    };
};

export default withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(BookablePackageRateDetail)
);